export { default } from './RecentSearch';
